module.exports = __webpack_public_path__ + "static/media/a.fbd32824.png";